import { Radio, RadioChangeEvent } from 'antd';
import React, { useRef, useState } from 'react';
import 'react4xp/parts/service-unreliable-taxpayers/service-unreliable-taxpayers.scss';
import { Recaptcha, RecaptchaWrapper } from '../../../react4xp/mixins/ui/recaptcha-v3';
import { ApiWrapper } from '/react4xp/mixins/api-template/api-template';
import PartWrapper from '/react4xp/mixins/ui/part-wrapper';
import ListForm from '/react4xp/parts/service-unreliable-taxpayers/ListForm';
import SearchForm from '/react4xp/parts/service-unreliable-taxpayers/SearchForm';

const ServiceUnreliableTaxpayers = (props: any) => {
    const { serviceSearchTitle, serviceListTitle } = props.config;
    const [searchTabActivated, setSearchTabActivated] = useState<string>('0');
    const captchaRef = useRef(null);
    const updateCaptureToken = () => {
        captchaRef.current?.updateToken();
    };

    const onRadioChangeHandler = (e: RadioChangeEvent) => {
        setSearchTabActivated(e.target.value);
    };

    return (
        <div className="service-page">
            <Recaptcha ref={captchaRef} />

            <Radio.Group
                size="large"
                onChange={onRadioChangeHandler}
                value={searchTabActivated}
            >
                <Radio.Button value="0">{serviceSearchTitle}</Radio.Button>
                <Radio.Button value="1">{serviceListTitle}</Radio.Button>
            </Radio.Group>

            {searchTabActivated == '0' ? (
                <SearchForm
                    {...props}
                    updateCaptureToken={updateCaptureToken}
                />
            ) : (
                <ListForm {...props} />
            )}
        </div>
    );
};

export default (props) => (
    <PartWrapper
        {...props}
        disableError
    >
        <RecaptchaWrapper>
            <ApiWrapper
                module="ServiceUnreliableTaxpayers"
                {...props}
            >
                <ServiceUnreliableTaxpayers {...props} />
            </ApiWrapper>
        </RecaptchaWrapper>
    </PartWrapper>
);
